// src/modules/IntegratedMessaging/components/display/Card.tsx

import { Avatar, AvatarImage, AvatarFallback } from '@shared/components/ui/shadcn/avatar';
import { Badge } from '@shared/components/ui/badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import { DropdownActions } from '../interaction/DropdownActions';
import { useTranslation } from 'react-i18next';

interface Props {
  id: number;
  name: string;
  logoUrl?: string;
  isActive?: boolean;
  onToggleActive: (id: number, active: boolean) => void;
  onEdit: (id: number) => void;
}

export const Card = ({ id, name, logoUrl, isActive = true, onToggleActive, onEdit }: Props) => {
  const { t } = useTranslation('integratedmessagingModule');

  return (
    <div className="flex flex-col justify-between h-full">
      <div className="flex items-start justify-between mb-4 gap-2 min-w-0">
        <div className="flex items-center gap-4 min-w-0 flex-1">
          <Avatar className="w-10 h-10 dark:bg-card-border flex-shrink-0">
            <AvatarImage src={logoUrl} alt={name} className="object-scale-down" />
            <AvatarFallback>{name}</AvatarFallback>
          </Avatar>
          <div className="text-xl font-medium truncate">{name}</div>
        </div>
        <div className="flex-shrink-0">
          <DropdownActions
            isActive={isActive}
            onToggleActive={() => onToggleActive(id, isActive)}
            onEdit={() => onEdit(id)}
          />
        </div>
      </div>
      <div>
        {isActive ? (
          <Badge variant="outline" className="!text-success gap-1 bg-bg-success border-0">
            <FontAwesomeIcon icon={faCircleCheck} className="text-xs" />
            <span className="text-xs">{t('status.active')}</span>
          </Badge>
        ) : (
          <Badge variant="outline" className="!text-error gap-1 bg-bg-error border-0">
            <FontAwesomeIcon icon={faCircleXmark} className="text-xs" />
            <span className="text-xs">{t('status.inactive')}</span>
          </Badge>
        )}
      </div>
    </div>
  );
};
